import { motion } from "framer-motion";
import { STATS } from "@/data/site";

const EASE = [0.76, 0, 0.24, 1];

export const Stats = () => (
    <section
        data-testid="stats-section"
        className="relative bg-[var(--ink)] text-white py-20 md:py-28 border-y border-white/10"
    >
        <div className="container-x">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-white/50 font-body mb-10">
                <span className="inline-block h-px w-10 bg-white/40" />
                <span>Impacto em números</span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-y-14 gap-x-6 border-t border-white/10 pt-14">
                {STATS.map((s, i) => (
                    <motion.div
                        key={s.label}
                        data-testid={`stat-${i}`}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{
                            duration: 0.9,
                            ease: EASE,
                            delay: i * 0.08,
                        }}
                        className={`px-2 md:px-6 ${
                            i > 0 ? "md:border-l md:border-white/10" : ""
                        }`}
                    >
                        <div className="font-display text-[16vw] md:text-[7vw] lg:text-[5.5vw] leading-none">
                            <span
                                className={
                                    i % 2 === 0
                                        ? "text-white"
                                        : "stroke-text text-[var(--sun)]"
                                }
                            >
                                {s.value}
                            </span>
                        </div>
                        <div className="mt-4 text-[11px] tracking-[0.32em] uppercase text-white/60 font-body">
                            {s.label}
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
